import { createTrackerForCategory } from '@gonfalon/analytics/createTrackerForCategory';

const trackExperimentApproval = createTrackerForCategory('Experiment Approvals');

type ExperimentApprovalEventProps = {
  experimentKey: string;
  iterationId: string;
  environmentKey: string;
};

export const trackExperimentApprovalRequested = ({
  experimentKey,
  iterationId,
  environmentKey,
}: ExperimentApprovalEventProps) =>
  trackExperimentApproval('Experiment Approval Requested', {
    experimentKey,
    iterationId,
    environmentKey,
  });

export const trackExperimentApprovalDenied = ({
  experimentKey,
  iterationId,
  environmentKey,
}: ExperimentApprovalEventProps) =>
  trackExperimentApproval('Experiment Approval Denied', {
    experimentKey,
    iterationId,
    environmentKey,
  });

export const trackExperimentApprovalSuccess = ({
  experimentKey,
  iterationId,
  environmentKey,
}: ExperimentApprovalEventProps) =>
  trackExperimentApproval('Experiment Approval Approved', {
    experimentKey,
    iterationId,
    environmentKey,
  });

export const trackExperimentApprovalTime = ({
  experimentKey,
  iterationId,
  environmentKey,
  durationMinutes,
}: ExperimentApprovalEventProps & { durationMinutes: number }) =>
  trackExperimentApproval('Experiment Approval Time', {
    experimentKey,
    iterationId,
    environmentKey,
    durationMinutes,
  });

export const trackExperimentApprovalEnabled = ({ environmentKey }: { environmentKey: string }) =>
  trackExperimentApproval('Experiment Approval Enabled', {
    environmentKey,
  });
